import moment from "moment";
import React, { useState } from "react";
import { projectTaskCommentCreationService } from "../../../../services/projectDetails";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

export default function TaskComment({ task, setTask }) {
  const [reply, setReply] = useState("");
  const [activeReplyId, setActiveReplyId] = useState(null);

  const usersData = useSelector((state) => state.auth.userInfoData);
  const DetailedProjectData = useSelector((state) => state.projectDetails.getDetailedProjectData);

  const toggleReplyInput = (commentId) => {
    setActiveReplyId(activeReplyId === commentId ? null : commentId); 
    setReply("");
  };

  const handleSubmitReply = async (commentId) => {
    if (!reply.trim()) {
      toast.error("Reply cannot be empty.");
      return;
    }

    const responseData = await projectTaskCommentCreationService({
      project_id: DetailedProjectData.project._id,
      task_id: task._id,
      userDetails: usersData._id,
      comments: reply,
      is_reply: true,
      comment_id: commentId,
      reply: reply,
    });

    if (responseData?.status === 200) {
      toast.success(responseData.message);
      setReply("");
      setActiveReplyId(null); 

      setTask((prevTask) => ({
        ...prevTask,
        comments: prevTask.comments.map((c) =>
          c._id === commentId
            ? { ...c, replies: [...c.replies, { reply, user_id: usersData }] }
            : c
        ),
      }));
    } else {
      toast.error(responseData.message);
    }
  };

  return (
    <>
      {task?.comments?.map((comment) => (
        <div className="mb-5" key={comment._id}>
          <hr className="my-5" />
          <div className="flex gap-3 mb-2">
            <div>
              <h4 className="text-tiny font-semibold text-theme-fg-1">
                {comment?.user_id?.last_name
                  ? `${comment.user_id.first_name} ${comment.user_id.last_name}`
                  : comment?.user_id?.first_name}
              </h4>
              <p className="text-xss text-theme-fg-3">
                {moment(comment.created_At).format("D MMM YYYY")}
              </p>
            </div>
          </div>

          <p className="text-tiny text-theme-fg-2 mb-1">{comment.comment}</p>
          <button
            onClick={() => toggleReplyInput(comment._id)}
            className="text-theme-accent text-xs font-medium"
          >
            {activeReplyId === comment._id ? "Cancel" : "Reply"}
          </button>

          <div className="w-[80%] ml-10">
            {comment?.replies?.map((item, index) => (
              <div key={index} className="mb-2">
                <h4 className="text-tiny font-semibold text-theme-fg-1">
                  {item?.user_id?.last_name
                    ? `${item.user_id.first_name} ${item.user_id.last_name}`
                    : item?.user_id?.first_name}
                </h4>
                <p className="text-xss text-theme-fg-3">
                  {moment(item.created_At).format("D MMM YYYY")}
                </p>
                <p className="text-tiny text-theme-fg-2 mb-2">{item.reply}</p>
              </div>
            ))}
          </div>

          {activeReplyId === comment._id && (
            <div className="flex items-center gap-2 mt-3">
              <input
                className="border border-theme-cream-3 focus:border-theme-accent rounded-theme-sm px-3 py-2.5 w-[80%] text-xs outline-none text-theme-fg-1"
                value={reply}
                onChange={(e) => setReply(e.target.value)}
                placeholder="Write your reply"
              />
              <button
                type="button"
                onClick={() => handleSubmitReply(comment._id)}
                className="bg-theme-ink hover:bg-theme-ink-2 px-4 py-2.5 text-white text-xs rounded-theme-sm"
              >
                Submit
              </button>
            </div>
          )}
        </div>
      ))}
    </>
  );
}
